<template>
    <svg
        width="24"
        height="24"
        class="gst-svg-icon gst-svg-icon--stroke"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.286 21.006a.762.762 0 1 0 0-1.524.762.762 0 0 0 0 1.524ZM20.857 21.006a.762.762 0 1 0 0-1.524.762.762 0 0 0 0 1.524Z"
            stroke="#333"
            stroke-miterlimit="10"
            stroke-linecap="square"></path>
        <path
            d="M15.397 14.53h5.383a1 1 0 0 1 .98 1.196l-.361 1.81a1 1 0 0 1-.98.803H16.78a1 1 0 0 1-.99-.868l-.531-3.978a1 1 0 0 0-.992-.868H14"
            stroke="#333"
            stroke-miterlimit="10"></path>
        <path
            d="M6.062 14.667V13v1.667Zm2.296 0v-3.334 3.334Zm2.296 0v-5 5ZM12.185 18H4.531a1.47 1.47 0 0 1-1.083-.488A1.744 1.744 0 0 1 3 16.333V4.667c0-.442.161-.866.448-1.179A1.47 1.47 0 0 1 4.531 3h4.276c.203 0 .397.088.54.244l4.145 4.512a.873.873 0 0 1 .224.589v7.988c0 .442-.161.866-.448 1.179a1.47 1.47 0 0 1-1.083.488Z"
            stroke="#333"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"></path>
    </svg>
</template>

<script>
export default {
    name: 'IconOrderReports',
};
</script>
